import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  message,
  InputNumber,
  Divider,
} from "antd";
import _ from "lodash";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import { KalamAndKayadTable } from "./FormsTable/KalamAndKayadTable";
import { MembersFromTable } from "./FormsTable/MembersFromTable";
import moment from "moment";

const { TextArea } = Input;
const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const WantedForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [newsType, setNewType] = useState(1);

  const [user, SetUser] = useState({});
  const [basicDistricts, SetBasicDistricts] = useState([]);
  const [pc_cities, SetPC_cities] = useState([]);
  const [isSave, setIsSave] = useState(null);
  const [fileData, setFileData] = useState({});
  const [imageUrl, setImageUrl] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const [imageSuccess, setImageSuccess] = useState(false);

  const [imagePdf, setPdfUrl] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfSuccess, setPdfSuccess] = useState(false);

  const [citySelected, SetCitySelected] = useState(false);
  const [stateSelected, SetStateSelected] = useState(false);

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [district, setDistrict] = useState([]);

  const [cityGhunhaSelected, SetGhunhaCitySelected] = useState(false);
  const [stateGhunhaSelected, SetGhunhaStateSelected] = useState(false);

  const [ghunhastates, setGhunhaStates] = useState([]);
  const [ghunhacities, setGhunhaCities] = useState([]);
  const [ghunhadistrict, setGhunhaDistrict] = useState([]);

  const [kalams, setkalam] = useState([]);
  const [kayda, setkayda] = useState([]);
  const [isKKButton, SetIsKKButton] = useState(false);
  const [kalamkayda, setKalamKyadaArr] = useState([]);
  const [optionWanted, SetWanted] = useState([]);

  const [newMemberList, SetNewMemberList] = useState([]);
  const [isMemberTxt, SetIsMemberTxt] = useState(null);

  const [registerNumber, SetRegisterNumber] = useState(0);
  const [registerNumberValue, SetRegisterNumberValue] = useState("");

  useEffect(() => {
    SetUser(props.user);
  }, [props.user]);

  useEffect(() => {
    if (props.resetFrom) {
      form.resetFields();
      form.setFieldsValue({ name: "" });
      setImageUrl("");
      setPdfUrl("");
    }
  }, [props.resetFrom]);

  useEffect(() => {
    if (props.dataWantedType && props.dataWantedType) {
      SetWanted(props.dataStates.dataWantedType);
    }
  }, [props.dataWantedType]);

  useEffect(
    (res) => {
      //console.log("props.dataStates", props.dataStates);
      if (
        props.dataStates &&
        props.dataStates.pc_countrystates &&
        props.dataStates.pc_countrystates
      ) {
        setStates([...props.dataStates.pc_countrystates]);
        setGhunhaStates([...props.dataStates.pc_countrystates]);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_cities &&
        props.dataStates.pc_cities
      ) {
        setCities([...props.dataStates.pc_cities]);
        setGhunhaCities([...props.dataStates.pc_cities]);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_dharms &&
        props.dataStates.pc_dharms
      ) {
        // SetDharm([...props.dataStates.pc_dharms])
      }
      if (
        props.dataStates &&
        props.dataStates.pc_crimetypes &&
        props.dataStates.pc_crimetypes
      ) {
        //SetCrimeType([...props.dataStates.pc_crimetypes])
      }
    },
    [props.dataStates]
  );

  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.basicDistricts) {
        // setInputField(props.basicInformationData[0]);
        setDistrict([...props.dataStates.basicDistricts]);
        setGhunhaDistrict([...props.dataStates.basicDistricts]);
      }
    },
    [props.dataStates && props.dataStates.basicDistricts]
  );

  useImperativeHandle(ref, () => ({
    onFinish(flag) {
      setIsSave(flag);
      form.submit();
    },
  }));

  const onFinish = (values) => {
    if (isSave) {
      values.membersList = [...newMemberList];
      let obj = {
        ...values,
        //districtName: getDistrictName(values.district),
        cityName: getCityName(values.city),
        files: fileData,
      };
      //console.log(JSON.stringify(obj))
      props.onFormFinish(obj);
    } else {
      props.onFormUpdate(values);
    }
  };

  // const handleUpload = (value) =>{
  //     setFileData(value);
  // }

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function beforeUpload(file) {
    if (parseInt(newsType) === 2) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
    } else if (parseInt(newsType) === 3) {
      const isJpgOrPng = file.type === "video/mp4";
      if (!isJpgOrPng) {
        message.error("You can only upload mp4 file!");
      }
      const isLt2M = file.size < 20000000;
      if (!isLt2M) {
        message.error("Video must smaller than 20MB!");
      }
      return isJpgOrPng && isLt2M;
    } else {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
        return false;
      }
      if (file.name) {
        const fileChecked_php = file.name.split(".php");
        if (fileChecked_php.length > 1) {
          message.error("Image can not upload malicious file!");
          return false;
        }
        const fileChecked_java = file.name.split(".java");
        if (fileChecked_java.length > 1) {
          message.error("Image can not upload malicious file!");
          return false;
        }
        const fileChecked_html = file.name.split(".html");
        if (fileChecked_html.length > 1) {
          message.error("Image can not upload malicious file!");
          return false;
        }
        const fileChecked_net = file.name.split(".net");
        if (fileChecked_net.length > 1) {
          message.error("Image can not upload malicious file!");
          return false;
        }
      }
      return isJpgOrPng && isLt2M;
    }
  }

  const handleUpload = (info) => {
    if (info.file.status === "uploading") {
      // this.setState({ loading: true });
      setImageLoading(true);
      setFileData(info);
      return;
    }

    if (imageSuccess) {
      getBase64(info.file.originFileObj, (imageUrl) => {
        setImageLoading(false);
        setImageUrl(imageUrl);
      });
    } else {
      setImageLoading(false);
      setImageUrl("");
      setImageSuccess(false);
      setPdfSuccess(false);
    }

    // if (info.file.status === 'uploading') {
    //   // this.setState({ loading: true });
    //   setImageLoading(true);
    //   setFileData(info);
    //   return;
    // }
    // if (info.file.status === 'done') {
    //   // Get this url from response in real world.
    //   getBase64(info.file.originFileObj, imageUrl =>
    //     {
    //       setImageLoading(false);
    //       setImageUrl(imageUrl)
    //     }
    //   );
    // }
  };

  const handleRemoveAccusedImage = (file) => {
    // let temp = fileList;
    // let tempIndex = _.findIndex(fileList,file)
    // temp && temp.length && temp.splice(tempIndex,1);
    // SetfileList([
    //   ...temp
    // ]);
    setImageUrl("");
  };

  function beforePdfUpload(file) {
    const isJpgOrPng = file.type === "application/pdf";
    if (!isJpgOrPng) {
      message.error("You can only upload PDF file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("PDF must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }

  const handlePdfUpload = (info) => {
    if (info.file.status === "uploading") {
      // this.setState({ loading: true });
      setPdfLoading(true);
      setFileData(info);
      return;
    }

    if (pdfSuccess) {
      getBase64(info.file.originFileObj, (pdfUrl) => {
        setPdfLoading(false);
        setPdfUrl(pdfUrl);
      });
    } else {
      setPdfLoading(false);
      setPdfUrl("");
      setPdfSuccess(false);
    }

    // if (info.file.status === 'uploading') {
    //   // this.setState({ loading: true });
    //   setImageLoading(true);
    //   setFileData(info);
    //   return;
    // }
    // if (info.file.status === 'done') {
    //   // Get this url from response in real world.
    //   getBase64(info.file.originFileObj, imageUrl =>
    //     {
    //       setImageLoading(false);
    //       setImageUrl(imageUrl)
    //     }
    //   );
    // }
  };

  const handleRemoveAccusedPdf = (file) => {
    // let temp = fileList;
    // let tempIndex = _.findIndex(fileList,file)
    // temp && temp.length && temp.splice(tempIndex,1);
    // SetfileList([
    //   ...temp
    // ]);
    setPdfUrl("");
  };

  const uploadButton = (
    <div>
      {imageLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload Image</div>
    </div>
  );

  const uploadPdfButton = (
    <div>
      {imageLoading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload PDF</div>
    </div>
  );

  const onCityChange = (value) => {
    clearDistrictSelected();
    SetCitySelected(true);
    props.onCityChange(value, 1);
  };
  const onStateChange = (value) => {
    SetStateSelected(true);
  };

  const clearDistrictSelected = () => {
    form.resetFields(["district"]);
  };

  const onGhunhaCityChange = (value) => {
    clearGhunhaDistrictSelected();
    SetGhunhaCitySelected(true);
    props.onGhunhaCityChange(value, 1);
  };

  const onGhunhaStateChange = (value) => {
    SetGhunhaStateSelected(true);
  };

  const clearGhunhaDistrictSelected = () => {
    form.resetFields(["ghunhadistrict"]);
  };

  const getDistrictName = (id) => {
    const { basicDistricts } = props.dataStates;
    //console.log("basicDistricts",basicDistricts);
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };
  const getCityName = (id) => {
    const { pc_cities } = props.dataStates;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.pc_kalams) {
        // setInputField(props.basicInformationData[0]);
        setkalam([...props.dataStates.pc_kalams]);
        // SetIsKKButton(true);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_acts &&
        props.dataStates.pc_acts
      ) {
        setkayda([...props.dataStates.pc_acts]);
      }
    },
    [props.dataStates && props.dataStates.pc_kalams]
  );

  const onkaydaChange = (value) => {
    clearKalamSelected();

    props.onKaydaChange(value);
  };
  const clearKalamSelected = () => {
    //SetIsKKButton(false);
    form.resetFields(["kalam"]);
    // SetIsKKButton(true);
  };

  const getActsNames = (id) => {
    const { pc_acts } = props.dataStates;
    if (pc_acts && pc_acts.length) {
      return (
        _.filter(pc_acts, function (o) {
          return o.act_cd === id;
        })[0] &&
        _.filter(pc_acts, function (o) {
          return o.act_cd === id;
        })[0].kayda
      );
    }
  };

  const addNewKalamKayda = () => {
    let ob = {
      rules: form.getFieldsValue().rules,
      kalam: form.getFieldsValue().kalam,
      rulesName: getActsNames(form.getFieldsValue().rules),
      // kalamName:getKalamNames(form.getFieldsValue().kalam)
    };
    setKalamKyadaArr([
      ...kalamkayda,
      {
        ...ob,
      },
    ]);
  };

  const deletekalamKayda = (values) => {
    if (values) {
      let tempkalamKayda = kalamkayda;
      let getIndex = _.findIndex(kalamkayda, values);
      let temp = tempkalamKayda.splice(getIndex, 1);
      if (temp && temp.length) {
        form.resetFields(["kalam"]);
        form.resetFields(["rules"]);
      }
      setTimeout(() => {
        setKalamKyadaArr([]);
        setKalamKyadaArr(tempkalamKayda);
      }, 100);
    }
  };

  const deletekalamKaydaAll = () => {
    let tempkalamKayda = kalamkayda;
    let temp = tempkalamKayda.splice(0, tempkalamKayda.length);
    if (temp && temp.length) {
      form.resetFields(["kalam"]);
      form.resetFields(["rules"]);
    }
    setTimeout(() => {
      setKalamKyadaArr([]);
      setKalamKyadaArr(tempkalamKayda);
    }, 100);
  };

  const validateMobileNumber = (callback) => {
    const { form } = this.props;
    let mnumber = form.getFieldValue("phone");
    if (mnumber.length != 10) {
      // console.log("invalid mobile nuumber");
    }
  };

  const addNewMemberName = () => {
    if (kalamkayda.length < 0) {
      let ob = {
        rules: form.getFieldsValue().rules,
        kalam: form.getFieldsValue().kalam,
      };
      setKalamKyadaArr([
        ...kalamkayda,
        {
          ...ob,
        },
      ]);
    }
    let newMember = {
      memberName: form.getFieldValue(["name"]),
      regsiterNumber: form.getFieldValue(["registernumber"]),
      registernumberYear: getDateFormatYear(
        form.getFieldValue(["registernumberYear"])
      ),
      accusedCourtCaseNo:
        form.getFieldValue(["registernumber"]) +
        "/" +
        getDateFormatYear(form.getFieldValue(["registernumberYear"])),
      ghunhastate: form.getFieldValue(["ghunhastate"]),
      ghunhacity: form.getFieldValue(["ghunhacity"]),
      ghunhacityName: getCityName(form.getFieldValue(["ghunhacity"])),
      ghunhadistrict: form.getFieldValue(["ghunhadistrict"]),
      ghunhadistrictName: getDistrictName(
        form.getFieldValue(["ghunhadistrict"])
      ),
      kalamkayda: [...kalamkayda],
    };
    SetNewMemberList([
      ...newMemberList,
      {
        ...newMember,
        ...kalamkayda,
      },
    ]);
    form.resetFields(["registernumber"]);
    form.resetFields(["registernumberYear"]);
    form.resetFields(["rules"]);
    form.resetFields(["kalam"]);
    // form.resetFields(["ghunhastate"]);
    // form.resetFields(["ghunhacity"]);
    // form.resetFields(["ghunhadistrict"]);
    deletekalamKaydaAll();
  };

  const getDateFormatYear = (value) => {
    if (value) {
      return moment(value).format("YYYY");
    }
  };

  const onRegisterNumberChange = (e) => {
    if (e.target.value) {
      SetRegisterNumber(1);
      SetRegisterNumberValue(e.target.value);
    } else {
      SetRegisterNumber(0);
      SetRegisterNumberValue("");
    }
  };

  const onDeleteMembers = (values) => {
    if (values) {
      let tempMember = newMemberList;
      let getIndex = _.findIndex(newMemberList, values);
      let temp = tempMember.splice(getIndex, 1);

      setTimeout(() => {
        SetNewMemberList([]);
        SetNewMemberList(tempMember);
      }, 100);
    }
  };

  const onMembernameChange = (value) => {
    if (value) {
      SetIsMemberTxt(true);
    } else {
      SetIsMemberTxt(null);
    }
  };

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="newsType"
            label="Perticular"
            rules={[
              {
                required: false,
                message: "Please select an Perticular",
              },
            ]}
          >
            <Select
              placeholder="Please select an Perticular"
              // rules={[{ required: false, message: "Please select Perticular" }]}
              style={{ width: "100%" }}
              value={newsType}
              onChange={(e) => {
                setNewType(e);
              }}
              defaultValue={["Wanted"]}
            >
              {props.dataWantedType &&
                props.dataWantedType.length &&
                props.dataWantedType.map((res, index) => (
                  <Option key={index} value={res.id}>
                    {res.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      {parseInt(newsType) === 1 ||
      parseInt(newsType) === 2 ||
      parseInt(newsType) === 3 ||
      parseInt(newsType) === 4 ||
      parseInt(newsType) === 5 ||
      parseInt(newsType) === 6 ||
      parseInt(newsType) === 7 ? (
        <>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="name"
                label="आरोपीचे नाव"
                rules={[
                  { required: true, message: "Please enter आरोपीचे नाव" },
                  {
                    pattern: new RegExp(
                      /^[\u0900-\u097F9a-zA-Z\-_.\s]+(?:\s[\u0900-\u097F-_9a-zA-Z0-9.]+)*$/i
                    ),
                    message: "Only enter valid format allowed!",
                  },
                ]}
              >
                <Input placeholder="Please enter आरोपीचे नाव" />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item
                name="address"
                label="Address"
                rules={[
                  { required: true, message: "Please enter address" },
                  {
                    pattern: new RegExp(
                      /^[\u0900-\u097F9a-zA-Z\-_.\s]+(?:\s[\u0900-\u097F-_9a-zA-Z0-9.]+)*$/i
                    ),
                    message: "Only enter valid format allowed!",
                  },
                ]}
              >
                <TextArea placeholder="Please enter address.." allowClear />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="state"
                label="राज्य"
                rules={[{ required: true, message: "Please select an state" }]}
              >
                <Select
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  onChange={onStateChange}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {states &&
                    states.length &&
                    states.map((res, index) => (
                      <Option key={index} value={res.id}>
                        {res.state}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="city"
                label="जिल्हा"
                rules={[{ required: true, message: "Please enter user city" }]}
              >
                <Select
                  onChange={onCityChange}
                  placeholder="Please select an City"
                  disabled={!stateSelected}
                  rules={[{ required: true, message: "Please select an City" }]}
                >
                  {cities &&
                    cities.length &&
                    cities.map((res, index) => (
                      <Option key={index} value={res.id}>
                        {res.City}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="district"
                label="आरोपीचे पोलिस ठाणे"
                rules={[
                  { required: true, message: "Please enter user district" },
                ]}
              >
                <Select
                  optionFilterProp="children"
                  placeholder="Please select an district"
                  disabled={!citySelected}
                >
                  {district &&
                    district.length &&
                    district.map((res, index) => (
                      <Option key={index} value={res.DistrictName}>
                        {res.DistrictName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="registernumber"
                label="गु.र.नंबर"
                rules={[{ required: false, message: "Please enter number" }]}
              >
                <Input
                  onChange={onRegisterNumberChange}
                  placeholder="Please enter number"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="registernumberYear"
                label="गु.र.नंबर वर्ष"
                rules={[{ required: false, message: "Please select year" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  picker={"year"}
                  inputReadOnly
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="rules"
                label="कायदा"
                rules={[{ required: false, message: "Please select an rules" }]}
              >
                <Select
                  placeholder="Please select an rules"
                  onChange={onkaydaChange}
                >
                  {kayda &&
                    kayda.length &&
                    kayda.map((res, index) => (
                      <Option key={index} value={res.act_cd}>
                        {res.kayda}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="kalam"
                label="कलम"
                rules={[{ required: false, message: "Please select an kalam" }]}
              >
                <Select
                  placeholder="Please select an kalam"
                  onChange={() => {
                    SetIsKKButton(true);
                  }}
                >
                  {kalams &&
                    kalams.length &&
                    kalams.map((res, index) => (
                      <Option key={index} value={res.section}>
                        {res.section}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item>
                <Button
                  style={{ marginTop: "30px" }}
                  type="button"
                  disabled={!isKKButton}
                  onClick={addNewKalamKayda}
                >
                  जोडा
                </Button>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              {kalamkayda && kalamkayda.length ? (
                <KalamAndKayadTable
                  data={kalamkayda}
                  deletekalamKayda={deletekalamKayda}
                  professionals={props.dataStates}
                ></KalamAndKayadTable>
              ) : null}
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="ghunhastate"
                label="गुन्हाचे राज्य"
                rules={[{ required: false, message: "Please select an state" }]}
              >
                <Select
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  onChange={onGhunhaStateChange}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {ghunhastates &&
                    ghunhastates.length &&
                    ghunhastates.map((res, index) => (
                      <Option key={index} value={res.id}>
                        {res.state}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="ghunhacity"
                label="गुन्हाचे जिल्हा"
                rules={[{ required: false, message: "Please enter user city" }]}
              >
                <Select
                  onChange={onGhunhaCityChange}
                  placeholder="Please select an City"
                  disabled={!stateGhunhaSelected}
                  rules={[{ required: true, message: "Please select an City" }]}
                >
                  {ghunhacities &&
                    ghunhacities.length &&
                    ghunhacities.map((res, index) => (
                      <Option key={index} value={res.id}>
                        {res.City}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="ghunhadistrict"
                label="गुन्हाचे पोलिस ठाणे"
                rules={[
                  { required: false, message: "Please enter user district" },
                ]}
              >
                <Select
                  optionFilterProp="children"
                  placeholder="Please select an district"
                  disabled={!cityGhunhaSelected}
                  onChange={onMembernameChange}
                >
                  {ghunhadistrict &&
                    ghunhadistrict.length &&
                    ghunhadistrict.map((res, index) => (
                      <Option key={index} value={res.id}>
                        {res.DistrictName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            {parseInt(newsType) === 3 ||
            parseInt(newsType) === 4 ||
            parseInt(newsType) === 5 ? (
              <Col span={8}>
                <Form.Item
                  name="tadipar_area"
                  label="Tadipar Area"
                  rules={[
                    { required: true, message: "Please enter tadhipar area" },
                  ]}
                >
                  <Input placeholder="Please enter tadhipar area" />
                </Form.Item>
              </Col>
            ) : (
              ""
            )}
          </Row>
          <Row>
            <Col span={8}>
              <Button
                style={{ marginTop: "30px" }}
                type="button"
                disabled={!registerNumber || !isMemberTxt}
                onClick={addNewMemberName}
              >
                आणखी जोडा
              </Button>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              {newMemberList && newMemberList.length ? (
                <MembersFromTable
                  data={newMemberList}
                  onDeleteMembers={onDeleteMembers}
                ></MembersFromTable>
              ) : null}
            </Col>
          </Row>

          <Divider />

          <Row span={24}>
            {
              <Col span={10} className="NewsUploadImage">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action=""
                  beforeUpload={(file) => {
                    setImageSuccess(beforeUpload(file));
                  }}
                  onChange={handleUpload}
                  onRemove={handleRemoveAccusedImage}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Col>
            }
            <Col span={2}></Col>
            {
              <Col span={10} className="NewsUploadImage">
                <Upload
                  name="pdf"
                  label="Upload PDF"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action=""
                  beforeUpload={(file) => {
                    setPdfSuccess(beforePdfUpload(file));
                  }}
                  onChange={handlePdfUpload}
                  onRemove={handleRemoveAccusedPdf}
                >
                  {imagePdf ? (
                    <img
                      src={imagePdf}
                      alt="avatar"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    uploadPdfButton
                  )}
                </Upload>
              </Col>
            }
          </Row>
        </>
      ) : parseInt(newsType) === 10 ? (
        <>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="license_number"
                label="License Number"
                rules={[
                  { required: true, message: "Please enter License Number" },
                ]}
              >
                <Input placeholder="Please enter License Number" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="owner_name"
                label="Owner Name"
                rules={[{ required: true, message: "Please enter Owner Name" }]}
              >
                <Input placeholder="Please enter Owner Name" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={16}>
              <Form.Item
                name="address"
                label="Address"
                rules={[
                  { required: true, message: "Please enter chassis number" },
                ]}
              >
                <TextArea
                  placeholder="Please enter chassis number"
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ) : parseInt(newsType) === 8 || parseInt(newsType) === 9 ? (
        <>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="vehical_no"
                label="Vehical Number"
                rules={[
                  { required: true, message: "Please enter Vehical Number" },
                ]}
              >
                <Input placeholder="Please enter Vehical Number" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="model"
                label="Model"
                rules={[{ required: true, message: "Please enter model" }]}
              >
                <Input placeholder="Please enter model" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="colour"
                label="colour"
                rules={[{ required: true, message: "Please enter colour" }]}
              >
                <Input placeholder="Please enter colour" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="chassis_no"
                label="Chassis Number"
                rules={[
                  { required: true, message: "Please enter chassis number" },
                ]}
              >
                <Input placeholder="Please enter chassis number" />
              </Form.Item>
            </Col>
          </Row>

          <Row span={24}>
            {
              <Col span={14} className="NewsUploadImage">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action=""
                  beforeUpload={(file) => {
                    setImageSuccess(beforeUpload(file));
                  }}
                  onChange={handleUpload}
                  onRemove={handleRemoveAccusedImage}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Col>
            }
          </Row>
        </>
      ) : parseInt(newsType) === 11 ||
        parseInt(newsType) === 12 ||
        parseInt(newsType) === 13 ? (
        <>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="mobile_no"
                label="Mobile Number"
                rules={[
                  { required: true, message: "Please enter Mobile Number" },
                  {
                    message: "Please enter numeric only",
                    pattern: new RegExp(/^[0-9]+$/),
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }
                      if (value.length < 10) {
                        return Promise.reject(
                          "Mobile Number can't be less than 10"
                        );
                      }
                      if (value.length > 10) {
                        return Promise.reject(
                          "Mobile Number can't be more than 10"
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder="Please enter Mobile Number" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="imei_no"
                label="IMEI NUMBER"
                rules={[
                  { required: true, message: "Please enter IMEI NUMBER" },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }
                      if (value.length < 15) {
                        return Promise.reject("Number can't be less than 15");
                      }
                      if (value.length > 15) {
                        return Promise.reject("Number can't be more than 15");
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder="Please enter IMEI NUMBER" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="model"
                label="Model"
                rules={[{ required: true, message: "Please enter Model" }]}
              >
                <Input placeholder="Please enter Model" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="colour"
                label="Colour"
                rules={[{ required: true, message: "Please enter colour" }]}
              >
                <Input placeholder="Please enter colour" />
              </Form.Item>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}

      {/*<Row gutter={16}>
      <Col span={12}>
      <Form.Item
              name="newsType"
              label="Perticular"
              rules={[
                {
                  required: true,
                  message: "Please select an Perticular",
                },
              ]}
            >
              <Select
                placeholder="Please select an Perticular"
                rules={[{ required: true, message: "Please select Perticular" }]}
                style={{width:'100%'}}
                value={newsType}
                onChange={(e) =>{setNewType(e)}}
              >
                    <Option key={1} value="1">Text</Option>
                    <Option key={2} value="2">Image</Option>
                    <Option key={3} value="3">Video</Option>
              </Select>
            </Form.Item>
            </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
              <Form.Item
                name="newdescription"
                label="Descriptions"
              >
                  <TextArea     placeholder="Please enter descriptions.." allowClear  />
              </Form.Item>
        </Col>
      </Row>
      <Row span={24}>
       {
         parseInt(newsType) === 2 || parseInt(newsType) === 3 ?<Col span={14} className="NewsUploadImage">
         <Upload  
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action=""
            beforeUpload={(file) => {setImageSuccess(beforeUpload(file))}}
            onChange={handleUpload}
            onRemove = {handleRemoveAccusedImage}
          >
            {imageUrl ? <img src={imageUrl} alt="avatar" style={{ maxWidth:'100%',maxHeight:'100%', objectFit:'contain' }} /> : uploadButton}
          </Upload>
        </Col>:null
       } 
        
        
      </Row>*/}
    </Form>
  );
});
